import PropTypes from 'prop-types';
import { cn } from '@/lib/utils';
import Button from '@/components/atoms/button';
import Logo from '@/components/atoms/logo';

const ActionHeader = ({ variant, btnText, classes, handleCloseBtn, handleBackBtn, ...props }) => {
	return (
		<div
			className={cn(
				'border-b border-formOutline z-[10]',
				// Note: bg colour
				variant === 'blue' ? 'bg-eis-light-blue-1' : 'bg-white',
				// Note: fixed its position at the top of the page
				'fixed top-0 left-0 w-full'
			)}
			{...props}
		>
			<div className={cn('flex items-center justify-between max-w-eis-1440 px-6 md:px-10 lg:px-14 xl:px-eis-72 py-3 mx-auto', classes)}>
				{btnText && (
					<Button
						variant="icon-and-underline"
						size="none"
						icon="chevron-left"
						iconAndUnderline="icon-and-underline"
						className="text-eis-black"
						onClick={handleBackBtn}
					>
						{btnText}
					</Button>
				)}

				<Logo name="logo-small" className="w-eis-43 h-eis-30 text-corporateBlue" />

				<Button variant="circle-icon" size="circle-icon" icon="close" onClick={handleCloseBtn} />
			</div>
		</div>
	);
};

export default ActionHeader;

ActionHeader.propTypes = {
	variant: PropTypes.oneOf(['blue', 'white']).isRequired,
	btnText: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	classes: PropTypes.string,
	handleCloseBtn: PropTypes.func,
	handleBackBtn: PropTypes.func,
};

ActionHeader.defaultProps = {
	variant: null,
	btnText: null,
	classes: null,
	handleCloseBtn: null,
	handleBackBtn: null,
};
